import { Text } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

export interface CampaignInquiryAdditionalNotesProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryAdditionalNotes = ({ campaignInquiry }: CampaignInquiryAdditionalNotesProps) => {
    if (!campaignInquiry?.additionalNotes) {
        return <Text color="dimmed">-</Text>;
    }

    return <Text>{campaignInquiry.additionalNotes}</Text>;
};
